<template>
	<croppa v-model="croppa" 
        :initial-image="imageUrl" 
        :show-remove-button="isEditable"
        :disable-click-to-choose="!isEditable" 
        :disable-drag-and-drop="!isEditable" 
        :disable-drag-to-move="!isEditable" 
        :disable-scroll-to-zoom="!isEditable" 
        :disable-pinch-to-zoom="!isEditable" 
        :disable-rotation="!isEditable" 
        :width="imgWidth" 
        :height="imgHeight" 
        :prevent-white-space="!isEditable"
        canvas-color="transparent"
        @init="onInit">
	</croppa>
</template>

<script>
import "vue-croppa/dist/vue-croppa.css";
import Vue from "vue";
import Croppa from "vue-croppa";
import CommonService from "@/service/CommonService";

Vue.use(Croppa);

export default {
	props: [
		"imgWidth",
		"TLWebFormat",
		"initialImage",
		"isEditable",
		"typeOfPicture",
	],
	data: function () {
		return {
			croppa: {},
		};
	},
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	computed: {
		imgHeight: {
			get() {
				if (this.TLWebFormat) return this.imgWidth * 1.4;
				else return this.imgWidth;
			},
		},
		imageUrl: {
			get() {
				if (
					this.initialImage == null ||
                    this.initialImage == "" ||
                    this.initialImage == "https://cdn.tirolibre.it" ||
					!this.commonService.UrlExists(this.initialImage)
				)
					switch (this.typeOfPicture) {
						case "player":
							return this.commonService.getDefaultPlayerAvatarUrl();
						case "team":
							return this.commonService.getDefaultTeamAvatarUrl();
						default:
						case "agent":
							return this.commonService.getDefaultAgentAvatarUrl();
					}
				else return this.initialImage;
			},
		},
	},
	methods: {
		onInit() {
			if (this.TLWebFormat) {
				// rectangle with border 50 (same format like in Tirolibre web)
				this.imgWidth = 132;
				this.croppa.addClipPlugin(function (ctx, x, y, w, h) {
					const r = 50;
					ctx.beginPath();
					ctx.moveTo(x + r, y);
					ctx.arcTo(x + w, y, x + w, y + h, r);
					ctx.arcTo(x + w, y + h, x, y + h, r);
					ctx.arcTo(x, y + h, x, y, r);
					ctx.arcTo(x, y, x + w, y, r);
					ctx.closePath();
				});
			} else {
				// circle
				this.croppa.addClipPlugin(function (ctx, x, y, w, h) {
					ctx.beginPath();
					ctx.arc(x + w / 2, y + h / 2, w / 2, 0, 2 * Math.PI, true);
					ctx.closePath();
				});
			}
		},
		getCroppedImage() {
			return this.croppa.generateDataUrl("image/png", 0.8);
		},
		handleCroppaFileTypeMismatch() {},
		handleCroppaFileSizeExceed() {},
	},
};
</script>

<style scoped>
.croppa-container {
	background-color: transparent;
}
</style>